import { render, staticRenderFns } from "./changeSopTemplateDialog.vue?vue&type=template&id=06cc5c00&scoped=true&"
import script from "./changeSopTemplateDialog.vue?vue&type=script&lang=js&"
export * from "./changeSopTemplateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cc5c00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06cc5c00')) {
      api.createRecord('06cc5c00', component.options)
    } else {
      api.reload('06cc5c00', component.options)
    }
    module.hot.accept("./changeSopTemplateDialog.vue?vue&type=template&id=06cc5c00&scoped=true&", function () {
      api.rerender('06cc5c00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Job/booking/tabs/changeSopTemplateDialog.vue"
export default component.exports